var MyBundle = (function (exports) {
  'use strict';

  const sizes = document.querySelector('.main-product__size');
  const sizesSelect = document.querySelector('.main-product__size-select');
  const sizesSelectToggle = () => {
    if (sizesSelect) {
      const sizesOptionsList = sizesSelect.parentElement.querySelector('.main-product__size-list');
      sizesSelect.addEventListener('click', function () {
        sizesOptionsList.classList.toggle('active');
      });
      const sizesOptionBtn = sizesOptionsList.querySelectorAll('.main-product__size-input');
      const sizesSelectText = sizes.querySelector('span');
      sizesOptionBtn.forEach(btn => {
        btn.removeAttribute('checked');
        btn.addEventListener('click', function () {
          sizesSelectText.textContent = btn.dataset.title;
          sizesOptionsList.classList.remove('active');
          btn.setAttribute('checked', 'checked');
        });
      });
    }
  };
  document.addEventListener('DOMContentLoaded', sizesSelectToggle());

  exports.sizesSelectToggle = sizesSelectToggle;

  return exports;

})({});
